import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface MetricCardProps {
  title: string;
  value: number | string;
  className?: string;
}

function MetricCard({ title, value, className }: MetricCardProps) {
  return (
    <Card
      className={cn(
        'rounded-lg border border-solid border-[var(--inv-border)] bg-[var(--inv-surface-muted)] shadow-[var(--inv-shadow,0_1px_2px_rgba(43,33,24,0.04))]',
        className,
      )}>
      <CardContent className="p-3.5">
        <p className="text-xs font-semibold uppercase tracking-wide text-[var(--inv-text-muted)]">
          {title}
        </p>
        <p className="mt-1 text-lg font-bold leading-tight text-[var(--inv-text)] sm:text-xl">
          {value}
        </p>
      </CardContent>
    </Card>
  );
}

export { MetricCard };
